import axios from 'axios'
import { CommonJobCodeEnum } from '@/api/services/common/job/common-job.dto'
import { CommonPersonnelResponse } from '@/api/services/common/personnel/common-personnel.dto'
import { CommonResponsibilityCodeEnum } from '@/api/services/common/responsibility/common-responsibility.dto'
import { EntityComparatorUtils } from '@/shared/util/entity-comparator-utils'

class CommonPersonnelService {
    async getPersonnelByJob(laboratoryId: number, jobEnum?: CommonJobCodeEnum): Promise<CommonPersonnelResponse[]> {
        const response = await axios.get<CommonPersonnelResponse[]>(`/laboratories/${laboratoryId}/personnel/index`, { params: { jobEnum } })
        return response.data
    }

    async getPersonnelByResponsibilities(responsibilities: CommonResponsibilityCodeEnum[], laboratoryId: number): Promise<CommonPersonnelResponse[]> {
        const response = await axios.get<CommonPersonnelResponse[]>(`/laboratories/${laboratoryId}/personnel/indexByResponsibilities`, { params: { responsibilities } })
        return response.data.sort(EntityComparatorUtils.comparePersonsByName)
    }

    async getAllPersonnelByResponsibilities(responsibilities: CommonResponsibilityCodeEnum[]): Promise<CommonPersonnelResponse[]> {
        const response = await axios.get<CommonPersonnelResponse[]>(`/personnel/findAllByResponsibilities`, { params: { responsibilities } })
        return response.data
    }
}

export const commonPersonnelService = new CommonPersonnelService()
